import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import type { AuthUser, LoginRequest } from '@s-blog/shared-types';
import { authApi } from '@/api/auth';

export const useAuthStore = defineStore('auth', () => {
  const user = ref<AuthUser | null>(null);
  const loading = ref(false);
  const authChecked = ref(false);

  const isAuthenticated = computed(() => user.value !== null);

  async function bootstrap() {
    if (authChecked.value) return;
    loading.value = true;
    try {
      user.value = await authApi.me();
    } catch {
      user.value = null;
    } finally {
      loading.value = false;
      authChecked.value = true;
    }
  }

  async function login(payload: LoginRequest) {
    user.value = await authApi.login(payload);
    authChecked.value = true;
  }

  async function logout() {
    try {
      await authApi.logout();
    } finally {
      user.value = null;
    }
  }

  return {
    user,
    loading,
    authChecked,
    isAuthenticated,
    bootstrap,
    login,
    logout,
  };
});
